import { render, staticRenderFns } from "./WorkDetailLayout.vue?vue&type=template&id=837829b2&"
import script from "./WorkDetailLayout.vue?vue&type=script&lang=js&"
export * from "./WorkDetailLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports